import React from "react"
import { trackSupport } from "../../utils/FunctionsForGa";
import configs from "../../contentConfig";

export const CHAT_SELECTOR = configs?.chat?.selector || "chat-oyo";

export const InnspireChatInitialize = (props, callback) => {
    let maxRetryIfInnspireChatReady = 5;

    const script = document.createElement('script');
    script.src = `https://guest-journey.s3.us-east-1.amazonaws.com/chatbot/1.3.52/chatbot.js`;
    script.async = true;

    script.onload = () => {
        const initializeLibrary = async () => {
            let innSpireChatConfig = {
                api_key: process.env.REACT_APP_CHAT_API_KEY,
                chatApi: process.env.REACT_APP_PROD_URL,
                selector: CHAT_SELECTOR,
                device_id: "asdasda",
                device_token: "sadawa121enlsda",
                device_type: "Android",
                creds: {
                        },
            }

            console.log("Innspire Chat Configs:")
            console.log(innSpireChatConfig);
            window.InnspireCB.config(innSpireChatConfig);
            
            setTimeout(() => {
                window.InnspireCB.chatbot.render()

                setTimeout(() => {
                    if(sessionStorage.getItem("openInnspireChatBot")){   
                        sessionStorage.removeItem("openInnspireChatBot");
                    }
                }, 2500);
            }, 1000);

            const checkInnspireChatReady = setInterval(() => {

                maxRetryIfInnspireChatReady--;
                if(maxRetryIfInnspireChatReady <= 0){
                    clearInterval(checkInnspireChatReady);
                }

                window.InnspireCB.chatbot.isReady && window.InnspireCB.chatbot.isReady()
                .then((isInnSpireChatReady) => {
                    if(isInnSpireChatReady){
                        clearInterval(checkInnspireChatReady);
                    }
                })
                .catch((err) => {
                    console.log("something went wrong checking innspirechat state: " + err)
                })
            }, 1000);
            
        }

        initializeLibrary();
    };

    script.onerror = (err) => {
        console.log("Something went wrong while initalising innspirechatbot" + JSON.stringify(err))
    }

 
    document.head.appendChild(script);
}

export const updateInnSpireChatGuestDetails = (data) => {
    if(window.InnspireCB) window.InnspireCB.chatbot.updateGuestDetails(data);
}

// export const getInnSpireChatUnreadCount = (callback) => {

//     if(window.InnspireCB){
//         window.InnspireCB.chatbot.get_msg_stat()
//         .then((res) => {
//             callback(+res.unread_msg_count)
//         })
//         .catch(() => {
//             callback(0);
//             console.log("error getting innSpireChat unread msg count")
//         })
//     } else {
//         callback(0);
//     }
// }

export const InnSpireChatShowConversation = (props) => {
    let retry = 1;
    const showChatBot = () => {
        try {
            if(window.InnspireCB) window.InnspireCB.chatbot.show();
            trackSupport()
    
            setTimeout(() => {
                props.setUnreadMessageCountWeb && props.setUnreadMessageCountWeb(0);
            }, 2000);   
        } catch (error) {
            console.log("error opening innspire chatbot");
            if(retry > 0){
                retry--;
                setTimeout(() => {showChatBot();}, 300);
            }
        }
    }

    showChatBot();
}